<template>
  <div class="hovefun">
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar v-if="datas != ''" :title="datas.data.name" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content" v-if="datas != ''">
      <img :src="datas.data.banner" />
      <div v-html="datas.data.content"></div>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "hovefun",
    data () {
      return  {
        datas:'',
        id:this.$route.query.id
      }
    },
    components: {
      TopNav
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas: function () {
        this.$api.get('WebApi/Index/Special/details', { id:this.id }, res => {
          this.datas=res.data
        })
      }
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
.hovefun{
  .van-content{
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/havefun.vue